import { Pipe, PipeTransform } from '@angular/core';
import { Month } from '@app/shared/models/shared.models';

@Pipe({
	name: 'monthLabel'
})
export class MonthLabelPipe implements PipeTransform {

	private readonly map = {
		[Month.January]: $localize`:@@common.january:January`,
		[Month.February]: $localize`:@@common.february:February`,
		[Month.March]: $localize`:@@common.march:March`,
		[Month.April]: $localize`:@@common.april:April`,
		[Month.May]: $localize`:@@common.may:May`,
		[Month.June]: $localize`:@@common.june:June`,
		[Month.July]: $localize`:@@common.july:July`,
		[Month.August]: $localize`:@@common.august:August`,
		[Month.September]: $localize`:@@common.september:September`,
		[Month.October]: $localize`:@@common.october:October`,
		[Month.November]: $localize`:@@common.november:November`,
		[Month.December]: $localize`:@@common.december:December`
	};

	transform (month: number): string {
		return this.map[month] || month;
	}
}